import { render } from "./EncyclopediaPage.vue?vue&type=template&id=202c1528&scoped=true"
import script from "./EncyclopediaPage.vue?vue&type=script&lang=js"
export * from "./EncyclopediaPage.vue?vue&type=script&lang=js"

import "./EncyclopediaPage.vue?vue&type=style&index=0&id=202c1528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202c1528"]])

export default __exports__